import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import api from "../api";
import "./followUp.css";

const EditFollowUp = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [followUp, setFollowUp] = useState(null);
  const [form, setForm] = useState({
    effettuato: false,
    dataFormazione: "",
    location: "",
    note: "",
  });
  const [errors, setErrors] = useState({});
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");

    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per modificare!");
      navigate("/login");
      localStorage.clear();
    } else {
      fetchFollowUp();
    }
  }, [navigate]);

  const fetchFollowUp = async () => {
    try {
      const res = await api.get(`/followup/${id}`);
      setFollowUp(res.data);
      setForm({
        effettuato: res.data.effettuato || false,
        dataFormazione: res.data.dataFormazione || "",
        location: res.data.location || "",
        note: res.data.note || "",
      });
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const validate = () => {
    const inputErrors = {};
    if (!form.note.trim()) inputErrors.note = "La nota non può essere vuota!";
    if (!form.location.trim())
      inputErrors.location = "La posizione non può essere vuota!";
    setErrors(inputErrors);
    return Object.keys(inputErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;

    try {
      setLoading(true);
      const payload = {
        trainerCodiceFiscale: followUp.trainer.codiceFiscale,
        effettuato: form.effettuato,
        dataFormazione: form.dataFormazione,
        location: form.location,
        note: form.note,
      };

      const res = await api.put(`/followup/${id}`, payload);
      if (res.status === 200) {
        toast.success("Follow-up aggiornato!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        setFollowUp(res.data);
        setEditMode(false);
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setForm({
      effettuato: followUp.effettuato || false,
      dataFormazione: followUp.dataFormazione || "",
      location: followUp.location || "",
      note: followUp.note || "",
    });
    setErrors({});
    setEditMode(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const isoDatePart = dateString.slice(0, 10);
    const [year, month, day] = isoDatePart.split("-");
    if (!year || !month || !day) return "";

    return `${day}.${month}.${year}`;
  };

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">
          <i className="fa-solid fa-edit"></i>
          Modifica Follow-Up
        </div>
        <div className="controls">
          <button onClick={() => navigate("/follow-up")} className="back-btn">
            <i className="fa-solid fa-arrow-left"></i>
            Torna ai Follow-Up
          </button>
        </div>
      </div>

      <div className="page-content followup">
        {followUp && (
          <div className="details-card">
            <div className="card-header">
              <div className="card-title">
                <i className="fa-solid fa-chart-line"></i>
                Dettagli Follow-Up #{followUp.id}
              </div>
              <div className="card-actions">
                {!editMode && (
                  <button
                    className="edit-btn"
                    onClick={() => setEditMode(true)}
                  >
                    <i className="fa-solid fa-edit"></i>
                    Modifica
                  </button>
                )}
              </div>
            </div>

            <div className="card-content">
              <div className="info-sections">
                <div className="info-section">
                  <div className="section-header">
                    <i className="fa-solid fa-info-circle"></i>
                    Informazioni Principali
                  </div>
                  <div className="info-grid">
                    <div className="info-item">
                      <label className="info-label">Docente:</label>
                      <span className="value-text">
                        {followUp.trainer?.nome} {followUp.trainer?.cognome}
                        {followUp.trainer?.codiceFiscale && ` - ${followUp.trainer.codiceFiscale}`}
                      </span>
                    </div>

                    <div className="info-item">
                      <label className="info-label">Stato:</label>
                      <div className="info-value">
                        {editMode ? (
                          <label className="modern-checkbox">
                            <input
                              type="checkbox"
                              name="effettuato"
                              checked={form.effettuato}
                              onChange={handleChange}
                            />
                            <span className="checkmark"></span>
                            <span className="checkbox-label">
                              {form.effettuato ? "Completato" : "In corso"}
                            </span>
                          </label>
                        ) : (
                          <span
                            className={`status-badge ${
                              form.effettuato ? "completed" : "pending"
                            }`}
                          >
                            <i
                              className={`fa-solid ${
                                form.effettuato ? "fa-check-circle" : "fa-clock"
                              }`}
                            ></i>
                            {form.effettuato ? "Completato" : "In corso"}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="info-item">
                      <label className="info-label">Data Formazione:</label>
                      <span className="value-text">
                        {formatDate(form.dataFormazione)}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="info-section">
                  <div className="section-header">
                    <i className="fa-solid fa-map-marker-alt"></i>
                    Dettagli Location
                  </div>
                  <div className="info-grid">
                    <div className="info-item">
                      <label className="info-label">Location:</label>
                      <div className="info-value">
                        {editMode ? (
                          <input
                            type="text"
                            name="location"
                            value={form.location}
                            onChange={handleChange}
                            className="modern-input"
                            placeholder="Inserisci la location"
                          />
                        ) : (
                          <span className="value-text">{form.location}</span>
                        )}
                        {errors.location && (
                          <span className="error-message">
                            <i className="fa-solid fa-exclamation-circle"></i>
                            {errors.location}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="info-section">
                  <div className="section-header">
                    <i className="fa-solid fa-sticky-note"></i>
                    Note
                  </div>
                  <div className="info-grid">
                    <div className="info-item full-width">
                      <label className="info-label">Note:</label>
                      <div className="info-value">
                        {editMode ? (
                          <textarea
                            name="note"
                            value={form.note}
                            onChange={handleChange}
                            placeholder="Inserisci le note"
                            className="modern-textarea"
                            rows={4}
                          />
                        ) : (
                          <span className="value-text">{form.note}</span>
                        )}
                        {errors.note && (
                          <span className="error-message">
                            <i className="fa-solid fa-exclamation-circle"></i>
                            {errors.note}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {editMode && (
                <div className="edit-actions">
                  <button className="btn-secondary" onClick={handleCancel}>
                    <i className="fa-solid fa-times"></i>
                    Annulla
                  </button>
                  <button className="btn-primary" onClick={handleSave}>
                    <i className="fa-solid fa-save"></i>
                    Salva Modifiche
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditFollowUp;
